var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"archives_index"}},[_c('index',[_c('archives-main',{on:{"detailsTap":_vm.detailsTap}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }